import axios from "axios";

const getCompetitionReq = async (idToken) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.get(
      "account/competition-list/",
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error during competition request:", error);
    throw error;
  }
};
const enterCompetition = async (data, idToken) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.post(
      "account/participate-competition/",
      data,
      config
    );
    return response;
  } catch (error) {
    console.error("Error during enter competition request:", error);
    throw error;
  }
};

const getLeaderboard = async (idToken, id) => {
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    }
  };

  const body = {
    competition_id: id
  };

  try {
    const response = await axios.post('/account/leaderboards/', body, config);

    if (response) {
      return response?.data;
    }
  } catch (error) {
    console.error(error);
  }
}

export { getCompetitionReq, enterCompetition, getLeaderboard };
